import { useLocation, matchPath } from 'react-router'
import { useMemo } from 'react'
import { routing } from '../../../routes'

const useCurrentRoute = () => {
  const location = useLocation()

  return useMemo(
    () =>
      Object.values(routing).find((value) =>
        matchPath({ path: value.path, end: true }, location.pathname),
      ),
    [location],
  )
}

export default useCurrentRoute
